import script from "./related.vue?vue&type=script&setup=true&lang=ts"
export * from "./related.vue?vue&type=script&setup=true&lang=ts"

import "./related.vue?vue&type=style&index=0&id=e123472e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e123472e"]])

export default __exports__